import React, {Fragment} from 'react';

import Slider from '../components/Slider/home-two'
import About from '../components/About/home-two'
import Services from '../components/Services'
import Features from '../components/Features'
import Testimonial from "../components/Testimonials/home-two";
import Team from "../components/Team/home-two";
import Blog from "../components/Blog";
import BrandLogo from "../components/BrandLogo";
import Funfact from "../components/Funfact";
import CallToAction from "../components/CallToAction";
import Footer from "../components/Footer";
import LoginRegister from "../components/LoginRegister";
import MobileMenu from "../components/MobileMenu";
import HeaderTwo from '../components/Header/indextwo';
import TestimonialSection from "../components/TestimonialsSectionTwo";
import Testimonials from "../components/Testimonials/home-one";
import AboutTwo from '../components/About/about-two';
import FooterTwo from '../components/Footer/indextwo';
import CallToActionTwo from '../components/CallToAction/indextwo';
import MobileMenuTwo from '../components/MobileMenu/indextwo';
import SpecialismSectionTwo from '../components/SpecialismTwo';
import MapTwo from "../components/MapTwo/MapTwo";
import ServicesTwo from '../components/Services/indextwo';
import ServicesTwoServices from '../components/Services/Indextwoservices';

const HomeTwo = () => {
    const jobs = [
        { regionId: 'E15000008', id: 101, title: 'Specialist Carer', regionName: 'Kent and Sussex Area' },
        { regionId: 'E15000007', id: 102, title: 'Healthcare Assistant', regionName: 'London' },
        { regionId: 'E15000007', id: 103, title: 'Mental Health Healthcare Assistant (MH HCA) ', regionName: 'London' },
        { regionId: 'E15000008', id: 104, title: 'Live-In Carer', regionName: 'Kent and Sussex Area' },
        { regionId: 'E15000007', id: 105, title: 'Care Coordinator ', regionName: 'London' },
        { regionId: 'E15000008', id: 106, title: 'Mental Health Healthcare Assistant (MH HCA)', regionName: 'Kent and Sussex Area' },
        { regionId: 'E15000007', id: 107, title: 'Live-In Carer', regionName: 'London' },
        { regionId: 'E15000007', id: 108, title: 'Specialist Carer', regionName: 'London' },
        { regionId: 'E15000008', id: 109, title: 'Healthcare Assistant', regionName: 'Kent and Sussex Area' },
        { regionId: 'E15000008', id: 110, title: 'Care Support Worker', regionName: 'Kent and Sussex Area' },
        { regionId: 'E15000008', id: 111, title: 'Care Coordinator', regionName: 'Kent and Sussex Area' },
        { regionId: 'E15000007', id: 112, title: 'Care Support Worker', regionName: 'London' },
    ];

    return (
        <Fragment>
            <HeaderTwo/>
            <Slider/>
            <AboutTwo/>
            <Features classes="sp-top"/>
            <ServicesTwo classes="sm-top-wt" />
            <div id="jobs">
                <MapTwo jobs={jobs} />
            </div>
            <SpecialismSectionTwo/>
            {/* <ServicesTwoServices classes="sm-top-wt" /> */}
            <Testimonials />
            <TestimonialSection />
            <Funfact ribbonColor="#BB2649" />
            <CallToActionTwo/>
            <FooterTwo/>
            <LoginRegister/>
            <MobileMenuTwo/>
        </Fragment>
    );
};

export default HomeTwo;